import { render, staticRenderFns } from "./forget_password.vue?vue&type=template&id=3f372da7&scoped=true&"
import script from "./forget_password.vue?vue&type=script&lang=js&"
export * from "./forget_password.vue?vue&type=script&lang=js&"
import style0 from "./forget_password.vue?vue&type=style&index=0&id=3f372da7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f372da7",
  null
  
)

export default component.exports